import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import StampRallyPage from './components/StampRally/StampRallyPage';
import NationalMapPage from './components/NationalMap/NationalMapPage';
import FourGodsPage from './components/FourGods/FourGodsPage';
import FiveKirinPage from './components/FourGods/FiveKirinPage';
import ErrorBoundary from './components/common/ErrorBoundary';
import AdminLoginPage from './components/Admin/AdminLoginPage';
import AdminPostsPage from './components/Admin/AdminPostsPage';
import RequireAdminAuth from './components/Admin/RequireAdminAuth';
import { DEFAULT_CAMPAIGN_ID } from './constants/lpConfig';

const DIARY_TOP_URL = 'https://diary.rural.ne.jp/';

/**
 * 外部URLへリダイレクトするコンポーネント
 * React Router の <Navigate> は内部パスにしか使えないため、
 * 外部URLへの遷移は window.location.replace を使用する。
 */
const ExternalRedirect = ({ to }) => {
  window.location.replace(to);
  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          {/* ★ フェーズ1.0 全国MAPビュー */}
          <Route path="/map" element={<NationalMapPage />} />
          <Route path="/map/:spotId" element={<NationalMapPage />} />

          {/* /stamprally → デフォルトキャンペーンにリダイレクト */}
          <Route
            path="/stamprally"
            element={<Navigate to={`/stamprally/${DEFAULT_CAMPAIGN_ID}`} replace />}
          />
          {/* /stamprally/:campaignId → スタンプラリーページ */}
          <Route
            path="/stamprally/:campaignId"
            element={<StampRallyPage />}
          />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/posts" element={<RequireAdminAuth><AdminPostsPage /></RequireAdminAuth>} />

          {/* ★ 2026.10.1 四神獣キャラクターランディングページ */}
          <Route path="/4gods/5kirin5" element={<FiveKirinPage />} />
          <Route path="/4gods/:godId" element={<FourGodsPage />} />

          {/* ルート・404 → diary.rural.ne.jp へリダイレクト */}
          <Route path="/" element={<ExternalRedirect to={DIARY_TOP_URL} />} />
          <Route path="*" element={<ExternalRedirect to={DIARY_TOP_URL} />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
